import axios from "axios";
import { authHeader } from "./auth-header";

const api = () => process.env.REACT_APP_API_URL || "";

const getMePermissions = () =>
  axios.get(api() + "admin/me/permissions", { headers: authHeader() });

export default { getMePermissions };
